import { render, staticRenderFns } from "./DebugBar.vue?vue&type=template&id=b8e56134&scoped=true"
import script from "./DebugBar.vue?vue&type=script&lang=js"
export * from "./DebugBar.vue?vue&type=script&lang=js"
import style0 from "./DebugBar.vue?vue&type=style&index=0&id=b8e56134&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e56134",
  null
  
)

export default component.exports